import React, { useEffect, useState, useContext, lazy } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import moment from "moment";

import LoggedInLayout from "../layout";
import SystemResources from "../pages/SystemResources";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import ForgetPassword from "../pages/ForgetPassword/";
import ResetPassword from "../pages/ResetPassword/";
import VerifyEmail from "../pages/VerifyEmail/";
import Connections from "../pages/Connections/";
import ResellerPanel from "../pages/ResellerPanel";
import AdminResellerPanel from "../pages/AdminResellerPanel";
import Settings from "../pages/Settings/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import UserManual from "../pages/UserManual";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Companies from "../pages/Companies/";
import Wallets from "../pages/Wallets/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections/";
import Reports from "../pages/Reports";
import RelatorioVendas from "../pages/RelatorioVendas";
import Subscription from "../pages/Subscription/";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files/";
import ToDoList from "../pages/ToDoList/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import BirthdaySettingsPage from "../pages/BirthdaySettings";
import CallHistoricals from "../pages/CallHistoricals";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault";
import MetaCommentAutomations from "../pages/MetaCommentAutomations";

import Floup from "../pages/Floup";
import FloupDashboard from "../pages/FloupDashboard";
import AiPackages from "../pages/AiPackages";

import AiApprovals from "../pages/AiApprovals"; // [ANTIGRAVITY]
import AiVideo from "../pages/AiVideo";
import Services from "../pages/Services";
import Professionals from "../pages/Professionals";
import PublicAppointment from "../pages/PublicAppointment";
import PublicBooking from "../pages/PublicBooking";
import FormsList from "../pages/FormsList"; // Added forms list
import PublicForm from "../pages/PublicForm"; // Added public form
import WhatsAppStatusScheduler from "../pages/WhatsAppStatusScheduler";
import GroupScheduler from "../pages/GroupScheduler";
import CommunityScheduler from "../pages/CommunityScheduler";
import WebWidget from "../pages/WebWidget";
import Appointments from "../pages/Appointments";
import Emails from "../pages/Emails";
import OAuthCallback from "../pages/Emails/OAuthCallback";
import BotMonitor from "../pages/BotMonitor";
import AiCreditPackages from "../pages/AiPackages";
import EventWebhooks from "../pages/EventWebhooks";
import WebhookLogs from "../pages/WebhookLogs";

const RoutesContent = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Verificar se a empresa está vencida
  const isCompanyExpired = () => {
    if (localStorage.getItem("isImpersonating") === "true") {
      return false; // Bypass for Impersonation
    }
    if (!user || !user.company || user.company.id === 1) {
      return false; // Empresa ID 1 nunca expira
    }

    const dueDate = user.company.dueDate;
    if (!dueDate) return false;

    // Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
    const hojeInicio = moment().startOf('day');
    const vencimentoInicio = moment(dueDate).startOf('day');

    // Empresa está vencida apenas após o dia do vencimento
    return hojeInicio.isAfter(vencimentoInicio, 'day');
  };

  return (
    <TicketsContextProvider>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/forget-password" component={ForgetPassword} />
        <Route exact path="/reset-password/:token" component={ResetPassword} />
        <Route exact path="/verify-email" component={VerifyEmail} />
        <Route exact path="/appointments/public/:uuid" component={PublicAppointment} isPublic />
        <Route exact path="/booking/:companyId" component={PublicBooking} isPublic />
        <Route exact path="/f/:slug" component={PublicForm} isPublic />
        <WhatsAppsProvider>
          <LoggedInLayout hideMenu={isCompanyExpired()}>
            <Route exact path="/forms" component={FormsList} isPrivate />
            <Route
              exact
              path="/financeiro"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/financeiro-aberto"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/companies"
              component={Companies}
              isPrivate
            />
            <Route
              exact
              path="/ai-packages"
              component={AiCreditPackages}
              isPrivate
            />
            <Route exact path="/ai-video" component={AiVideo} isPrivate />

            <Route
              exact
              path="/birthday-settings"
              component={BirthdaySettingsPage}
              isPrivate
            />
            <Route exact path="/" component={Dashboard} isPrivate />
            <Route
              exact
              path="/call-historicals"
              component={CallHistoricals}
              isPrivate
            />
            <Route exact path="/bot-monitor" component={BotMonitor} isPrivate />
            <Route
              exact
              path="/tickets/:ticketId?"
              component={TicketResponsiveContainer}
              isPrivate
            />
            <Route
              exact
              path="/connections"
              component={Connections}
              isPrivate
            />
            <Route
              exact
              path="/quick-messages"
              component={QuickMessages}
              isPrivate
            />
            <Route exact path="/todolist" component={ToDoList} isPrivate />
            <Route
              exact
              path="/schedules"
              component={Schedules}
              isPrivate
            />
            <Route exact path="/prompts" component={Prompts} isPrivate />
            <Route exact path="/admin/resellers" component={AdminResellerPanel} isPrivate />
            <Route exact path="/appointments" component={Appointments} isPrivate />
            <Route exact path="/tags" component={Tags} isPrivate />
            <Route exact path="/emails" component={Emails} isPrivate />
            <Route exact path="/emails/oauth/callback" component={OAuthCallback} isPrivate />
            <Route exact path="/contacts" component={Contacts} isPrivate />
            <Route
              exact
              path="/contacts/import"
              component={ContactImportPage}
              isPrivate
            />
            <Route exact path="/wallets" component={Wallets} isPrivate />
            <Route exact path="/helps" component={Helps} isPrivate />
            {user.super && (
              <Route exact path="/manual" component={UserManual} isPrivate />
            )}
            <Route exact path="/users" component={Users} isPrivate />
            <Route
              exact
              path="/messages-api"
              component={MessagesAPI}
              isPrivate
            />
            <Route
              exact
              path="/settings"
              component={Settings}
              isPrivate
            />
            <Route
              exact
              path="/reseller-panel"
              component={ResellerPanel}
              isPrivate
            />
            <Route exact path="/queues" component={Queues} isPrivate />
            <Route exact path="/reports" component={Reports} isPrivate />
            <Route
              exact
              path="/relatorio-vendas"
              component={RelatorioVendas}
              isPrivate
            />
            <Route
              exact
              path="/queue-integration"
              component={QueueIntegration}
              isPrivate
            />
            <Route
              exact
              path="/event-webhooks"
              component={EventWebhooks}
              isPrivate
            />

            <Route
              exact
              path="/webhook-logs"
              component={WebhookLogs}
              isPrivate
            />
            <Route
              exact
              path="/announcements"
              component={Annoucements}
              isPrivate
            />
            <Route exact path="/chats/:id?" component={Chat} isPrivate />
            <Route exact path="/files" component={Files} isPrivate />
            <Route
              exact
              path="/moments"
              component={ChatMoments}
              isPrivate
            />
            <Route exact path="/Kanban" component={Kanban} isPrivate />
            <Route
              exact
              path="/TagsKanban"
              component={TagsKanban}
              isPrivate
            />
            <Route exact path="/prompts" component={Prompts} isPrivate />
            <Route
              exact
              path="/allConnections"
              component={AllConnections}
              isPrivate
            />

            <Route
              exact
              path="/plugins/floup"
              component={Floup}
              isPrivate
            />
            <Route
              exact
              path="/plugins/floup/dashboard"
              component={FloupDashboard}
              isPrivate
            />


            <Route
              exact
              path="/flowbuilders"
              component={FlowBuilder}
              isPrivate
            />
            <Route
              exact
              path="/meta-comments"
              component={MetaCommentAutomations}
              isPrivate
            />
            <Route
              exact
              path="/flowbuilder/:id?"
              component={FlowBuilderConfig}
              isPrivate
            />
            <Route
              exact
              path="/services"
              component={Services}
              isPrivate
            />
            <Route
              exact
              path="/professionals"
              component={Professionals}
              isPrivate
            />
            <Route
              exact
              path="/whatsapp-status-scheduler"
              component={WhatsAppStatusScheduler}
              isPrivate
            />
            <Route
              exact
              path="/group-scheduler"
              component={GroupScheduler}
              isPrivate
            />
            <Route
              exact
              path="/community-scheduler"
              component={CommunityScheduler}
              isPrivate
            />


            <Route
              exact
              path="/web-widget"
              component={WebWidget}
              isPrivate
            />

            {showCampaigns && (
              <>
                <Route
                  exact
                  path="/contact-lists"
                  component={ContactLists}
                  isPrivate
                />
                <Route
                  exact
                  path="/contact-lists/:contactListId/contacts"
                  component={ContactListItems}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaign/:campaignId/report"
                  component={CampaignReport}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns"
                  component={Campaigns}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-config"
                  component={CampaignsConfig}
                  isPrivate
                />
              </>
            )}
            <Route exact path="/resources" component={SystemResources} isPrivate />
          </LoggedInLayout>
        </WhatsAppsProvider>
          </Switch>
      <ToastContainer position="top-center" autoClose={3000} style={{ zIndex: 99999 }} />
    </TicketsContextProvider>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
